// Simple encryption/decryption utility
const encryptPassword = (password) => {
  return btoa(password); // Base64 encoding
};

export { encryptPassword };